import getRandomStr from './getRandomStr';
/**
 * OPTIMIZELY FULL STACK (NOT OPTIMIZELY WEB)
 * if optimizelyFallbackId is set in localStorage then return it otherwise create a random id, set it on localStorage and return the newly created id
 * @returns {String} Returns a optimizely fallback id
 */
const getOptimizelyFallbackId = () => {
    const optimizelyFallbackId = typeof window !== 'undefined' ? localStorage.getItem('optimizelyFallbackId') : '';
    if (optimizelyFallbackId) {
        return optimizelyFallbackId;
    }
    const id = getRandomStr();
    if (typeof window !== 'undefined') {
        localStorage.setItem('optimizelyFallbackId', id);
    }
    return id;
};
export default getOptimizelyFallbackId;
//# sourceMappingURL=getOptimizelyFallbackId.js.map